/**
 * Central brand image constants — referenced across pages.
 * Real Unsplash photography selected by the design agent + supplied packaging assets.
 */
export const LOGO_PRIMARY = "/brand/sugaspice-roundel.png";

export const LOGO_ROUNDEL = "/brand/sugaspice-roundel.png";

export const LOGO_WHITE = "/brand/sugaspice-roundel-white.png";

export const LOGO_WORDMARK = "/brand/wordmark.jpeg";

export const PACK_BAG = "/brand/pack-bag.jpeg";

export const PACK_BOX = "/brand/pack-box.jpeg";

export const IMG = {
  hero_pastries:
    "https://images.unsplash.com/photo-1778399980486-5262c74e5f2c?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxhcnRpc2FuJTIwY3JvaXNzYW50JTIwcGFzdHJ5JTIwYmFrZXJ5fGVufDB8fHx8MTc3ODY2ODkyMXww&ixlib=rb-4.1.0&q=75&w=800",
  pastries_plate:
    "https://images.unsplash.com/photo-1778399943827-f0f1ca2e82a8?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxhcnRpc2FuJTIwY3JvaXNzYW50JTIwcGFzdHJ5JTIwYmFrZXJ5fGVufDB8fHx8MTc3ODY2ODkyMXww&ixlib=rb-4.1.0&q=75&w=800",
  pastries_mixed:
    "https://images.unsplash.com/photo-1751151856149-5ebf1d21586a?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxhcnRpc2FuJTIwY3JvaXNzYW50JTIwcGFzdHJ5JTIwYmFrZXJ5fGVufDB8fHx8MTc3ODY2ODkyMXww&ixlib=rb-4.1.0&q=75&w=800",
  burger_dark:
    "https://images.unsplash.com/photo-1678110707289-ab14382a1625?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxzbWFzaCUyMGJ1cmdlciUyMHByZW1pdW0lMjBkYXJrfGVufDB8fHx8MTc3ODY2ODkyMXww&ixlib=rb-4.1.0&q=75&w=800",
  burger_board:
    "https://images.unsplash.com/photo-1713330801172-03f8d1c0dde7?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxzbWFzaCUyMGJ1cmdlciUyMHByZW1pdW0lMjBkYXJrfGVufDB8fHx8MTc3ODY2ODkyMXww&ixlib=rb-4.1.0&q=75&w=800",
  interior_main: "/brand/shop-counter.webp",
  interior_wood: "/brand/shop-sign.webp",
  interior_display: "/brand/shop-display.webp",
  fried_chicken:
    "https://images.unsplash.com/photo-1626074353765-517a681e40be?q=80&w=800&auto=format&fit=crop",
  indian_street:
    "https://images.unsplash.com/photo-1606491956689-2ea866880c84?q=80&w=800&auto=format&fit=crop",
  bread_artisan:
    "https://images.unsplash.com/photo-1509440159596-0249088772ff?q=80&w=800&auto=format&fit=crop",
  coffee_pour:
    "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?q=80&w=800&auto=format&fit=crop",
  cake_slice:
    "https://images.unsplash.com/photo-1565958011703-44f9829ba187?q=80&w=800&auto=format&fit=crop",
  cookies:
    "https://images.unsplash.com/photo-1568051243851-f9b136146e97?q=80&w=800&auto=format&fit=crop",
  sandwich:
    "https://images.unsplash.com/photo-1521390188846-e2a3a97453a0?q=80&w=800&auto=format&fit=crop",
  wholesale_delivery:
    "https://images.unsplash.com/photo-1605002619349-82dce91bcee0?crop=entropy&cs=srgb&fm=webp&q=75&w=800&auto=format&fit=crop",
  breakfast_bap:
    "https://images.pexels.com/photos/3129826/pexels-photo-3129826.jpeg?auto=compress&cs=tinysrgb&w=800",
  breakfast_muffin:
    "https://images.pexels.com/photos/6529815/pexels-photo-6529815.jpeg?auto=compress&cs=tinysrgb&w=800",
  breakfast_baguette:
    "https://images.pexels.com/photos/6529638/pexels-photo-6529638.jpeg?auto=compress&cs=tinysrgb&w=800",
  doughnuts:
    "https://images.pexels.com/photos/4615516/pexels-photo-4615516.jpeg?auto=compress&cs=tinysrgb&w=800",
  loaded_fries:
    "https://images.pexels.com/photos/17035142/pexels-photo-17035142.jpeg?auto=compress&cs=tinysrgb&w=800",
  chicken_strips:
    "https://images.pexels.com/photos/2338407/pexels-photo-2338407.jpeg?auto=compress&cs=tinysrgb&w=800",
  hot_counter:
    "https://images.pexels.com/photos/4109997/pexels-photo-4109997.jpeg?auto=compress&cs=tinysrgb&w=800",
  chicken_burger:
    "https://images.unsplash.com/photo-1637710847214-f91d99669e18?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxjcmlzcHklMjBjaGlja2VuJTIwYnVyZ2VyJTIwYnJpb2NoZSUyMGJ1bnxlbnwwfHx8fDE3ODE4NzI0MTB8MA&ixlib=rb-4.1.0&q=75&w=800",
  wings_tenders:
    "https://images.unsplash.com/photo-1623653387945-2fd25214f8fc?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxmcmllZCUyMGNoaWNrZW4lMjB3aW5ncyUyMGFuZCUyMHRlbmRlcnMlMjBiYXNrZXR8ZW58MHx8fHwxNzgxODcyNDEwfDA&ixlib=rb-4.1.0&q=75&w=800",
  sauces_dips:
    "https://images.unsplash.com/photo-1563599175592-c58dc214deff?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxkaXBwaW5nJTIwc2F1Y2VzJTIwYm93bHMlMjBjb25kaW1lbnRzfGVufDB8fHx8MTc4MTg3MjQxMHww&ixlib=rb-4.1.0&q=75&w=800",
  samosas:
    "https://images.unsplash.com/photo-1772729996007-40bad08b3c40?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxzYW1vc2ElMjBwYXN0cnklMjBzYXZvdXJ5JTIwc25hY2tzfGVufDB8fHx8MTc4MTg3MjQxMHww&ixlib=rb-4.1.0&q=75&w=800",
};
